import { Component, OnInit } from '@angular/core';
import { RestCallerService } from '../../common/services/rest-caller.service';
declare var jquery: any;
declare var $: any;
declare var swal: any;

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  constructor(private restCallerService: RestCallerService) { }

  ngOnInit() {
  }

  getUserName() {
    let firstName: string = this.restCallerService.getUserDetails()['firstName'];
    let lastName: string = this.restCallerService.getUserDetails()['lastName'];
    lastName = (lastName) ? lastName.trim() : "";
    let fullName:string = '';
    fullName += firstName;
    if (lastName !== '')
      fullName += ' ' + lastName;
    return fullName;
  }

  isUserExternal() {
    let isExternal = this.restCallerService.getUserDetails()['externalUser'];
    return isExternal;
  }


  showOptions(event) {
    event.preventDefault();
    $('.dropdown-menu').toggle();
    event.stopPropagation();
    if ($('.dropdown-menu').is(':visible')) {
      $('div.main-wrapper').on('click', function (evnt) {
        if ($('.dropdown-menu').is(':visible') && evnt.target.className !== 'nav-link dropdown-toggle'
          && evnt.target.className !== 'name') {
          $('.dropdown-menu').slideUp('slow');
        }
        $('div.main-wrapper').off('click');
      });
    }
  }

  toggleMenu() {
    if (!$('.app').hasClass('sidebar-open') === true) {
      $('.app').addClass('sidebar-open');
      $('.sidebar').addClass('side-bar-open');

      $('div.main-wrapper').on('click', function (evnt) {
        if ($('.app').hasClass('sidebar-open') && (evnt.target.className !== 'fa fa-bars' && evnt.target.className !== 'collapse-btn')) {
            $('.app').removeClass('sidebar-open');
            $('.sidebar').removeClass('side-bar-open');
            $('div.main-wrapper').off('click');
        }
      });
    } else {
      $('.app').removeClass('sidebar-open');
      $('.sidebar').removeClass('side-bar-open');
    }
  }

  logout(event) {
    swal({
      title: 'Submit Current Quarter!',
      text: 'Please make sure to submit the data for each employee. You must receive a confirmation verifying submission of data.',
      icon: 'warning',
      buttons: {
        back: "Go Back",
        logout: "Logout"
      }
    }).then((value) => {
      switch (value) {
        case "back":
          break;
        case "logout":
          event.preventDefault();
          this.restCallerService.logout();
          break;
        default:
          break;
      }
    });
  }
  
}



// WEBPACK FOOTER //
// ./src/app/home/header/header.component.ts